// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"637":"8760bc33","930":"0944a156"}[chunkId] + ".css";
};